module.exports = __webpack_public_path__ + "img/logo_BRI_1.39c53e83.png";